import React from 'react';

export const LOGO_URL = process.env.PUBLIC_URL + '/assets/pikachu-logo.jpeg';

// Logo displayed exactly as provided — no borders, no rounded frame, no cropping.
export default function Logo({ height = 56, showText = false }) {
  return (
    <div className="flex items-center gap-3">
      <img
        src={LOGO_URL}
        alt="Pikachu Classes"
        className="block object-contain"
        style={{ height, width: 'auto' }}
      />
      {showText && (
        <div className="leading-tight hidden md:block">
          <div className="text-[10px] uppercase tracking-[0.2em] text-[#4FB3B8] font-bold">
            Home Tuitions
          </div>
        </div>
      )}
    </div>
  );
}
